import { render, staticRenderFns } from "./BalanceComponent.vue?vue&type=template&id=18309914&scoped=true"
import script from "./BalanceComponent.vue?vue&type=script&lang=js"
export * from "./BalanceComponent.vue?vue&type=script&lang=js"
import style0 from "./BalanceComponent.vue?vue&type=style&index=0&id=18309914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18309914",
  null
  
)

export default component.exports